import { createContext, useContext } from 'react';

import { ResolvedAnnouncement } from '@/contexts/announcements/model/Announcements.model.ts';

type AnnouncementsContextValue = {
  /** Announcements follow the announcement read permission; without it none are fetched or offered. */
  canReadAnnouncements: boolean;
  closePanel: () => void;
  currentRouteAnnouncements: ResolvedAnnouncement[];
  currentRouteUnseenCount: number;
  isPanelOpen: boolean;
  openPanel: () => void;
  previewAnnouncement: (announcementId: string) => void;
  registerAnchor: (anchorKey: string, element: HTMLElement) => void;
  unregisterAnchor: (anchorKey: string, element?: HTMLElement) => void;
};

const AnnouncementsContext = createContext<AnnouncementsContextValue | null>(null);

export const AnnouncementsContextProvider = AnnouncementsContext.Provider;

export const useAnnouncements = (): AnnouncementsContextValue => {
  const context = useContext(AnnouncementsContext);

  if (!context) {
    throw new Error('useAnnouncements must be used within AnnouncementsProvider');
  }

  return context;
};
